import {makeStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React from "react";

const useStyles = makeStyles(() => ({
    smallNextButton: {
        padding: '5px 30px',
    },
    smallPreviousButton: {
        color: '#FFFFFF',
        backgroundColor: '#6D6F80',
        padding: '5px 30px',
        '&:hover': {
            backgroundColor: '#91919a',
        }
    },
    smallButtonLabel: {
        fontSize: '1.125rem',
        fontWeight: 400,
        lineHeight: '21px',
        letterSpacing: '0.00714em',
        textTransform: 'none',
        display: 'inline'
    }
}))

export const NavigationButtons = ({activeStep, nextStep, prevStep}) => {
    const classes = useStyles()

    return <Grid item container xs spacing={4}>
        <Grid item>
            <Button variant={'contained'}
                    disabled={activeStep === 0}
                    classes={{contained: classes.smallPreviousButton}}
                    onClick={prevStep}
            >
                <Typography variant={'body1'}
                            classes={{body1: classes.smallButtonLabel}}>Назад</Typography>
            </Button>
        </Grid>
        {activeStep !== 2 ? <Grid item>
            <Button variant={'contained'}
                    color={"primary"}
                    classes={{contained: classes.smallNextButton}}
                    onClick={nextStep}
            >
                <Typography variant={'body1'}
                            classes={{body1: classes.smallButtonLabel}}>Далее</Typography>
            </Button>
        </Grid> : null}
    </Grid>
}